import React, { useState } from "react";
import { Box, Button, Link, Typography, useTheme } from '@mui/material';

interface INavBarProps {
  onBylawChange: () => void;
  onReportBug: () => void;
  currentBylaw: string;
}

const NavBar : React.FC<INavBarProps> = (props: INavBarProps) => {
  const { onBylawChange, onReportBug, currentBylaw = 'Old' } = props;

  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.palette.common.darkBlue,      
        marginBottom: '30px',
        boxSizing: 'border-box',
        padding: '0px 20px',
        '@media screen and (max-width: 768px)': { width: 'auto', flexDirection: 'inherit' }

      }}>

      <Typography
        onClick={() => window.location.href = '/'}
        sx={{
          fontSize: '30px',
          padding: '0.5% 0% 0.5% 7%',
          margin: '0px 0px 0px 0px',
          color: theme.palette.common.white,
          cursor: 'pointer'
        }}
      >
        CHS Absence Tool
        <sub style={{fontSize:'12px', color: 'white'}}>  v3.0.0 </sub>
      </Typography>

      <Box 
        sx={{
          display: 'flex', 
          gap: '15px', 
          '@media screen and (max-width: 768px)': { flexDirection: 'row-reverse'},

        }}>
        <Button 
          id={`switch-to-${currentBylaw === 'New' ? 'old' : 'new'}-button`}
          onClick={() => onBylawChange()} 
          sx={{ 
            background: currentBylaw === 'New' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
            height: '40px', 
            color: theme.palette.common.black, 
            padding: '0px 10px',
            fontSize: 13, 
            fontWeight: 500, 
            '@media screen and (max-width: 768px)': { height: '25px', minHeight: 'auto' },

            ':hover': {background: currentBylaw === 'New' ? theme.palette.common.oldBylawHoverColor : theme.palette.common.newBylawHoverColor}
          }}
        >
          Switch to {currentBylaw === 'New' ? 'Old' : 'New'} Byalw 
        </Button>
        <Button 
          onClick={() => onReportBug()}
          sx={{ 
            background: theme.palette.common.bugRed, 
            height: '40px', 
            color: theme.palette.common.white, 
            padding: '0px 10px',
            fontSize: 13,
            fontWeight: 500, 
            '@media screen and (max-width: 768px)': { height: '25px', minHeight: 'auto' },
            ':hover': {background: theme.palette.common.bugRedHover}
          }}>
          Report Bug
        </Button>

      </Box>
    </Box>
  );
}

export default NavBar; 